module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp2_3009.4843a454.png";